import * as React from "react";

const Upload2 = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2465_7804)"
    >
      <path d="M8 9V2M13.5 9v4h-11V9M5.5 4.5 8 2l2.5 2.5"></path>
    </g>
    <defs>
      <clipPath id="clip0_2465_7804">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default Upload2;
